/* eslint-disable import/prefer-default-export */
import { gql } from '@apollo/client/core';

export const SENDBIRD_TOKEN_QUERY = gql`
  query sendbirdSessionToken {
    sendbirdSessionToken {
      expiresAt
      token
    }
  }
`;

export const SITTER_DETAILS_FOR_PARENT_QUERY = gql`
  query sitterMessagingDetails($accountId: UUID!) {
    account(id: $accountId) {
      ... on Sitter {
        canReview
        hasVisibleProfile
        providerType
      }
    }
  }
`;

export { FETCH_PARENT_OPEN_JOBS } from '@/graphql/jobs/parentOpenJobs';
export type { JobNode, JobEdge, ViewerJobs } from '@/graphql/jobs/parentOpenJobs';
